import TrailingReturnsChart from "components/charts/modern/TrailingReturnsChart";
import useBrazilianRealEstateFundIssuer from "components/company/v3/context/hooks/useBrazilianRealEstateFundIssuer";

export default function FiisHistoricalReturnContent() {
  const issuer = useBrazilianRealEstateFundIssuer();

  if (!issuer.trailingReturns) {
    return null;
  }

  return <TrailingReturnsChart tickerSymbols={[issuer.tickerSymbol]} />;
}
